export default __webpack_public_path__ + "static/media/stealth-creation-success.6437d2c8.png";